module.exports = __webpack_public_path__ + "img/menu_button1.af64cb65.svg";